import type { InMemoryCacheConfig } from '@apollo/client'

import fragmentMatcher from '~/@types/generated/backend/fragmentTypes.json'
import { verificationTypePolicies } from '~/features/Verification/apollo/cache'

export const inMemoryCacheOptions: InMemoryCacheConfig = {
  possibleTypes: fragmentMatcher.possibleTypes,
  typePolicies: {
    DefaultTeasersPayload: {
      keyFields: ['id', 'productType'],
    },
    DrawResultsPayload: {
      keyFields: ['drawDate', 'serialNumber'],
    },
    FixedCharge: {
      keyFields: false,
    },
    ImagePropertiesPayload: {
      keyFields: ['blurHash'],
    },
    PlayerPayload: {
      keyFields: ['email'],
    },
    VersionedConfig: {
      merge: true,
    },
    ...verificationTypePolicies,
  },
}
